import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import { ServicePage, SparePartsPage, AboutPage, ContactPage, NotFoundPage } from "@/pages/StaticPages";
import BrandPage from "@/pages/BrandPage";
import { AdminLogin, ProtectedAdmin } from "@/pages/admin/AdminShell";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { AdminProducts } from "@/pages/admin/AdminProducts";
import { AdminProductForm } from "@/pages/admin/AdminProductForm";
import { AdminCategories, AdminBrands } from "@/pages/admin/AdminTaxonomy";
import { AdminMedia } from "@/pages/admin/AdminMedia";
import { AdminEnquiriesProduct, AdminEnquiriesSparePart, AdminEnquiriesContact } from "@/pages/admin/AdminEnquiries";
import { AdminHomepageSettings } from "@/pages/admin/AdminHomepageSettings";
import { AdminArticles, AdminPagesCms } from "@/pages/admin/AdminPlaceholders";
import { AdminBusinessSettings, AdminSEOSettings, AdminUsers } from "@/pages/admin/AdminSettings";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/produk" element={<ProductsPage />} />
              <Route path="/produk/:slug" element={<ProductDetailPage />} />
              <Route path="/brand/:slug" element={<BrandPage />} />
              <Route path="/service" element={<ServicePage />} />
              <Route path="/spare-parts" element={<SparePartsPage />} />
              <Route path="/tentang-kami" element={<AboutPage />} />
              <Route path="/hubungi-kami" element={<ContactPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
            <Route path="/admin/products" element={<ProtectedAdmin><AdminProducts /></ProtectedAdmin>} />
            <Route path="/admin/products/new" element={<ProtectedAdmin><AdminProductForm /></ProtectedAdmin>} />
            <Route path="/admin/products/:id" element={<ProtectedAdmin><AdminProductForm /></ProtectedAdmin>} />
            <Route path="/admin/categories" element={<ProtectedAdmin><AdminCategories /></ProtectedAdmin>} />
            <Route path="/admin/brands" element={<ProtectedAdmin><AdminBrands /></ProtectedAdmin>} />
            <Route path="/admin/media" element={<ProtectedAdmin><AdminMedia /></ProtectedAdmin>} />
            <Route path="/admin/enquiries/product" element={<ProtectedAdmin><AdminEnquiriesProduct /></ProtectedAdmin>} />
            <Route path="/admin/enquiries/spare-parts" element={<ProtectedAdmin><AdminEnquiriesSparePart /></ProtectedAdmin>} />
            <Route path="/admin/enquiries/contact" element={<ProtectedAdmin><AdminEnquiriesContact /></ProtectedAdmin>} />
            <Route path="/admin/content/homepage" element={<ProtectedAdmin><AdminHomepageSettings /></ProtectedAdmin>} />
            <Route path="/admin/content/articles" element={<ProtectedAdmin><AdminArticles /></ProtectedAdmin>} />
            <Route path="/admin/content/pages" element={<ProtectedAdmin><AdminPagesCms /></ProtectedAdmin>} />
            <Route path="/admin/settings/business" element={<ProtectedAdmin><AdminBusinessSettings /></ProtectedAdmin>} />
            <Route path="/admin/settings/seo" element={<ProtectedAdmin><AdminSEOSettings /></ProtectedAdmin>} />
            <Route path="/admin/settings/users" element={<ProtectedAdmin><AdminUsers /></ProtectedAdmin>} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
